import React from 'react';
import PT from 'prop-types';
// import classNames from 'classnames';
import _ from 'lodash';

import * as css from './Slider';

class Slider extends React.Component {
	static propTypes = {
		// className: PT.string,
		items: PT.shape({}).isRequired,
	};

	// static defaultProps = {
	// 	className: '',
	// };

	constructor(props) {
		super(props);
		this.state = {
			images: _.get(props, 'items.data', ''),
			// fadedleft: true,
			// fadedright: false,
			start: 0,
			finish: 5,
		};
	}

	leftClick = () => {
		const { start, finish } = this.state;

		if (start > 0 && finish > 0) {
			this.setState({
				start: start - 1,
				finish: finish - 1,
			});
		} else {
			// this.setState({ fadedleft: true });
		}
		// this.setState({ fadedright: false });
	};

	rightClick = () => {
		const { start, finish, images } = this.state;
		if (finish < images.length) {
			this.setState({
				start: start + 1,
				finish: finish + 1,
			});
		} else {
			// this.setState({ fadedright: true });
		}

		// this.setState({ fadedleft: false });
	};

	render() {
		const { items } = this.props;
		return (
			<div className="container">
				<div className="slideshow row col-md-12">
					<div className={css.fadedleft} onClick={this.leftClick.bind}></div>
					{_.map(items, item => (
						<div key={`slide-${item.id}`}>{item.name}</div>
					))}
					<div className={css.fadedright} onClick={this.rightClick}></div>
				</div>
			</div>
		);
	}
}

export default Slider;
